const data = `// HOW TO USE BALLOT MULTIPLIERS
//
// If the first character of the first column in the first row is #,
// then the first column of every subsequent row is treated as a multiplier 
// provided that it is a positive number.
//
// Negative numbers and non-numbers in the first column are ignored.

"# of ballots"; Allie; Billy; Candace; Dennis; Edith; Frank; Georgie; Harold
5; 5; 5; 4; 3; 3; 2; 1; 0
12; 4; 0; 2; 3; 1; 0; 5; 3
7; 0; 3; 2; 3; 4; 5; 3; 4
8; 3; 2; 0; 5; 4; 0; 2; 1
16; 2; 4; 1; 3; 5; 0; 1; 1
10; 0; 5; 1; 4; 5; 3; 4; 2
14; 3; 4; 0; 2; 5; 0; 1; 5
11; 3; 5; 0; 5; 1; 4; 0; 4
8; 2; 4; 5; 1; 1; 3; 2; 0
9; 3; 0; 1; 4; 2; 5; 5; 5
0; 2; 0; 5; 2; 0; 4; 3; 1
`;

export default data;
